import { render, staticRenderFns } from "./primaryRightColumnBlock.vue?vue&type=template&id=dc58ba5c&scoped=true"
import script from "./primaryRightColumnBlock.vue?vue&type=script&lang=js"
export * from "./primaryRightColumnBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc58ba5c",
  null
  
)

export default component.exports